$(document).ready(function(){
	var lastScrollTop = 0;
	var i = 0;
	$(window).bind('scroll', function (e) {
		var parallaxElement = $(".parallax_scroll"),
			parallaxQuantity = parallaxElement.length;
		var parallaxElementQuick = $(".parallax_scroll_quick"),
			parallaxQuantityQuick = parallaxElementQuick.length;
		// for slower scroll
		window.requestAnimationFrame(function () {
			for (var i = 0; i < parallaxQuantity; i++) {
				var currentElement = parallaxElement.eq(i),
					windowTop = $(window).scrollTop(),
					elementTop = currentElement.offset().top,
					elementHeight = currentElement.height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight;
				currentElement.css({
					transform: "translate3d(0," + scrolled * -0.15 + "px, 0)"
				});
			}

			// for faster scroll
			for (var i = 0; i < parallaxQuantityQuick; i++) {
				var currentElement = parallaxElementQuick.eq(i),
					windowTop = $(window).scrollTop(),
					elementTop = currentElement.offset().top,
					elementHeight = currentElement.height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight;
				currentElement.css({
					transform: "translate3d(0," + scrolled * -0.3 + "px, 0)"
				});
			}
		});

	});
	var i = 0;
    var lastScrollTop = 0;

	// check if target element is on view port
	$.fn.is_on_screen = function() {
		var win = $(window);
		var viewport = {
			top: win.scrollTop(),
			left: win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();

		var bounds = this.offset();
		bounds.right = bounds.left + this.outerWidth();
		bounds.bottom = bounds.top + this.outerHeight();

		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};


	// text slide animation on page scroll
	$(window).scroll(function(){
		// check if the div is on viewport
		var texts_to_slide = [
			'frame-design-overview',
			'frame-design-overview-2',
			'frame-design-overview-3',
			'frame-design-overview-4',
			'frame-design-highlight-2'
		]

		var text_to_slide_ids = [
			'frame-design-overview-first',
			'frame-design-overview-second',
			'frame-design-overview-third',
			'frame-design-overview-fourth',
		]

		for(var k=0; k<texts_to_slide.length; k++)
		{
			if ($('.' + texts_to_slide[k]).length > 0 && text_to_slide_ids.indexOf(texts_to_slide[k])===-1 && $('.' + texts_to_slide[k]).is_on_screen())
			{
				var st = $(this).scrollTop();
				if (st > lastScrollTop){
					$('.'+texts_to_slide[k] + " .svg_text_wrapper").css('margin-left', '-' + i + 'px');
					i += 3;
				} else {
					$('.'+texts_to_slide[k] + " .svg_text_wrapper").css('margin-left', '-' + i + 'px');
					i -= 3;
				}
				lastScrollTop = st;
			}
		}



		for(var k=0; k<text_to_slide_ids.length; k++)
		{
			if ($('#' + text_to_slide_ids[k]).length >0 && $('#' + text_to_slide_ids[k]).is_on_screen())
			{
				var st = $(this).scrollTop();

				if (st > lastScrollTop){
					$('#'+text_to_slide_ids[k] + " .svg_text_wrapper").css('margin-left', '-' + i + 'px');
					i += 3;
				} else {
					$('#'+text_to_slide_ids[k] + " .svg_text_wrapper").css('margin-left', '-' + i + 'px');
					i -= 3;
				}
				lastScrollTop = st;
			}
		}
	});

})